import React from "react";

const ChartCard: React.FC<{
  title: string;
  children: React.ReactNode;
  className?: string;
}> = React.memo(({ title, children, className }) => (
  <div
    className={`bg-white rounded-2xl shadow-md p-6 transition hover:shadow-lg flex flex-col items-center justify-center${className ? ` ${className}` : ""}`}
  >
    <h2 className="font-semibold text-xl mb-4 text-secondary-800 text-center">
      {title}
    </h2>
    <div className="w-full flex justify-center items-center">{children}</div>
  </div>
));

ChartCard.displayName = "ChartCard";

export default ChartCard;
